import { CreditNotesWorkspace } from "@/features/invoices/components/CreditNotesWorkspace";

export function CreditNotesPage() {
  return <CreditNotesWorkspace />;
}
